export default class OrderFilter {
  ClientReference: string;
  QuestelEntityIds: Guid[];
  ClientIds: Guid[];
  EPAttorneyIds: Guid[];
  StatusIds: number[];
  TypeIds: number[];
    DocuSign?: boolean;
    UserIds: Guid[];
    OrderNumber: string;

  constructor() {
    this.ClientReference = '';
    this.QuestelEntityIds = [];
    this.ClientIds = [];
    this.EPAttorneyIds = [];
    this.StatusIds = [];
    this.TypeIds = [];
    this.DocuSign = undefined;
    this.UserIds = [];
    this.OrderNumber = "";
  }
}